import React from 'react';
import './SecuritySection.scss';

const SECURITY_ITEMS = [
  {
    id: 'chiffrement',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2 4 5.5V11c0 5.2 3.4 8.9 8 10 4.6-1.1 8-4.8 8-10V5.5L12 2Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    text: 'Chiffrement HTTPS/TLS et AES-256',
  },
  {
    id: 'auth',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="9" r="3.2" stroke="currentColor" strokeWidth="1.6" />
        <path
          d="M10.3 11.3 18.5 19.5M15.5 16.5l2.2-2.2M18 14l2.5-2.5"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    text: 'Authentification multi-facteurs',
  },
  {
    id: 'sauvegarde',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="12" cy="6" rx="7" ry="2.6" stroke="currentColor" strokeWidth="1.6" />
        <path
          d="M5 6v5.5c0 1.4 3.1 2.6 7 2.6s7-1.2 7-2.6V6M5 11.5V17c0 1.4 3.1 2.6 7 2.6s7-1.2 7-2.6v-5.5"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    text: 'Sauvegarde automatique quotidienne',
  },
  {
    id: 'tracabilite',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 3v5h5M9 14l2 2 4-4"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    text: 'Traçabilité complète : qui, quand, quoi',
  },
];

const SecuritySection = () => {
  return (
    <div className="unfm-security">
      <section className="security">
        <div className="security__container">
          <span className="security__icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect
                x="5"
                y="11"
                width="14"
                height="9"
                rx="2"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinejoin="round"
              />
              <path
                d="M8 11V7.5a4 4 0 0 1 8 0V11"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>

          <h2 className="security__title">Vos données sont protégées</h2>

          <p className="security__subtitle">
            Un dossier correspond à une base de données centrale unique :
            tous les acteurs accèdent à la même information en temps réel,
            mais chacun ne voit que ce qui concerne son rôle.
          </p>

          <ul className="security__grid">
            {SECURITY_ITEMS.map((item) => (
              <li className="security__item" key={item.id}>
                <span className="security__item-icon">{item.icon}</span>
                <span className="security__item-text">{item.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
};

export default SecuritySection;